import React, {useState} from 'react';
import {
    Box,
    Button,
    Container,
    Center,
    Flex,
    Image, ModalOverlay,
    Text, useDisclosure,
} from "@chakra-ui/react"
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectFade, Navigation, Pagination} from "swiper";
import {BsDot} from "react-icons/bs"
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import {homeBanner} from "../../helpers/adminData";
import {Link} from "react-scroll"
import PopUpContact from "./PopUpContact";
import { WHATSAPP_LINK } from '../../helpers/adminData';
import {IoLogoWhatsapp} from "react-icons/io";

const Hero = () => {
    const OverlayOne = () => <ModalOverlay bg="rgba(0, 0, 0, 0.7)"/>;
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [overlay, setOverlay] = useState(<OverlayOne/>);

    return (
        <Box name="home" w="full" mb="70px">
            <Container maxW="container.xl" className="hero">
                <Swiper
                    spaceBetween={30}
                    effect={"fade"}
                    navigation={false}
                    pagination={{
                        clickable: true,
                    }}
                    slidesPerView={"auto"}
                    grabCursor={true}
                    loop={true}
                    centeredSlides={false}
                    autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                    }}
                    modules={[EffectFade, Autoplay, Navigation, Pagination]}
                    className="mySwiper"
                >
                    {homeBanner.map(({img, id, item, imgMobile}) => (
                        <SwiperSlide key={id}>
                            <Flex w="100%" h="100%" justifyContent="center" pos="relative" borderRadius={{base:"20px",md:"30px"}} >
                                <Image display={{base: "none", sm: "block"}}  src={img} w="100%" h="100%" zIndex="1" borderRadius={{base:"20px",md:"30px"}} alt=""/>
                                <Image display={{base: "block", sm: "none"}} src={imgMobile} w="924px" h="full" zIndex="1" borderRadius={{base:"20px",md:"30px"}} alt=""/>
                                <Box w="full" h="full" borderRadius="30px" pos="absolute" zIndex="2" top="0" left="0" bg="linear-gradient(182.04deg, rgba(0, 0, 0, 0.87) 14.53%, rgba(49, 40, 40, 0) 98.26%);"/>
                                <Box pos="absolute" zIndex="3" mt="101px">
                                    <Text textAlign="center" fontFamily='Raleway'
                                          fontSize={{base: "24px", sm: "42px", md: "64px"}} fontWeight="900"
                                          color="#FFFFFF">Пром&nbsp;Сталь&nbsp;Кей&nbsp;Джи</Text>
                                    <Text my="20px" textAlign="center" fontFamily='Raleway'
                                          fontSize={{base: "20px", md: "24px"}} fontWeight="600" color="#FFFFFF">Отливка Деталей из <br/> Металла Любой Сложности</Text>
                                    <Center>
                                        <BsDot fontSize="30px" color="white"/>
                                        <Text textAlign="center" fontFamily='Raleway' fontSize="24px" fontWeight="700"
                                              color="#FFFFFF">{item}</Text>
                                        <BsDot fontSize="30px" color="white"/>
                                    </Center>
                                    <Center mt="54px" fontFamily='Raleway' h="52px" fontSize="16px" fontWeight="700">
                                        <Button onClick={() => {
                                            setOverlay(<OverlayOne/>)
                                            onOpen()
                                        }} variant="none" w="221px" p="15px 70px" bg="#E92F34" borderRadius="10px"
                                                color="#ffffff">Связаться</Button>
                                        <Link to={"about-us"} smooth duration={500}>
                                            <Button display={{base: "none", md: "block"}} variant="none" mx="20px" w="167px" p="10px 24px" bg="#FFFFFF" color="#E92F34">Узнать&nbsp;больше</Button>
                                        </Link>
                                    </Center>
                                </Box>
                            </Flex>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </Container>
            <a href={WHATSAPP_LINK} target={'_blank'}>
                <Button position={'fixed'} right='30px' bg={'#1BC95C'} w='60px' h='60px' rounded='full' zIndex={'10'} top={'600px'}>
                    <IoLogoWhatsapp color='#fff'  fontSize={'30px'}/>
                </Button>
            </a>
            <PopUpContact isOpen={isOpen} onClose={onClose} overlay={overlay}/>
        </Box>
    );
};

export default Hero;
